export const GET_PERMISSOINSLIST = "GET_PERMISSOINSLIST";
export const GET_PERMISSOINDETAIL = "GET_PERMISSOINDETAIL";
export const EDIT_PERMISSOINS = "EDIT_PERMISSOINS";
